<template>
  <div class="page" v-cloak>
    <navbar></navbar>

    <!-- 顶部状态-->
    <div class="header-block">
      <!-- //-1：已取消，0：未支付，1：已支付待发货，2：已发货 -->
      <div class="header-tips" v-if="isType == 0">
        <div class="header-tips-title">您还没有付款哟</div>
        <div class="header-tips-desc">
          如果未能在30分钟内完成兑换，订单将要取消。
        </div>
      </div>

      <div class="header-tips" v-else-if="isType == 1">
        <div class="header-tips-title">已兑换等待发货</div>
        <div class="header-tips-desc">
          请稍等，我们已经开始打包尽快给您发出。
        </div>
      </div>

      <div class="header-tips" v-else-if="isType == 2">
        <div class="header-tips-title">兑换已发货请耐心等待</div>
        <div class="header-tips-desc">如果收到商品有问题请及时联系我们。</div>
      </div>
      <div class="header-tips" v-else>
        <div class="header-tips-title">兑换已完成</div>
        <div class="header-tips-desc">
          感谢您的支持，您的支持是我们最大的动力。
        </div>
      </div>

      <!-- <div class="header-tips" v-else-if="isType == 4">
        <div class="header-tips-title">交易已关闭</div>
        <div class="header-tips-desc">订单已经取消，如果你有什么问题请联系我们。</div>
      </div>

      <div class="header-tips" v-else-if="isType == 5">
        <div class="header-tips-title">兑换已完成</div>
        <div class="header-tips-desc">感谢您的支持，您的支持是我们最大的动力。</div>
      </div> -->
    </div>

    <!-- 收货地址 -->
    <div class="mation-block">
      <div class="address-l">收货地址</div>
      <div class="line"></div>
      <div class="mation-info">
        <div class="mation-name">
          {{ details.contactName }} {{ details.contactMobile }}
        </div>
        <div class="mation-time">{{ details.address }}</div>
        <div class="mation-address" v-if="details.memberRemark">
          {{ details.memberRemark }}
        </div>
      </div>
    </div>

    <div class="goods-block">
      <div v-for="(item, index) in details.products" :key="index">

        <div class="order-info-block">
          <img class="img" :src="item.productImage" />

          <div class="info-block">
            <div class="name">{{ item.productName }}</div>
            <span class="udc">{{ item.sku }}</span>

            <div class="price-block">
              <div class="price-tips">数量 {{ item.quantity }}</div>
            </div>
          </div>

        </div>
        <!-- 物流信息 -->
        <div class="delivery-block"  v-if="item.deliveryCode">
          <div class="delivery-express-l">物流信息</div>
          <div class="delivery-line"></div>
          <div class="delivery-info">
            <div class="delivery-name">快递公司:{{ item.deliveryCompany }}</div>
            <div class="delivery-time">
              快递单号:
              <span id="copyExpress">{{ item.deliveryCode }}</span>
              <span class="copy" data-clipboard-target="#copyExpress">复制单号</span>
            </div>

          </div>
        </div>

      </div>
      <!-- <div class="total-block btb">
        <div class="total-left">
          <span class="total-tips">共1件</span>
          <span>小计</span>
        </div>
        <div class="total-right">¥{{ details.goodsAmount }}</div>
      </div> -->

      <!-- <div class="total-block">
        <div class="total-left">
          <span class="total-tips">物品</span>
          <span v-if="details.payMethod">{{ details.payMethod }}</span>
        </div>
        <div class="total-right">-{{ details.totalAmount }}</div>
      </div> -->

      <!-- <div class="total-block">
    <div class="total-left">
      <text class="total-tips">上海地区包邮</text>
      <text>运费</text>
    </div>
    <div  class="total-right">+0.00</div>
  </div> -->

      <!-- <div class="total-block">
        <div class="total-left">
          <span></span>
          <span>实付金额</span>
        </div>
        <div class="total-price">¥{{ details.payAmount }}</div>
      </div> -->
    </div>

    <!-- 底部详情 -->
    <div class="order-detail">
      <div class="order-detail-tips">订单信息</div>
      <div class="total-block">
        <div class="total-left">
          <span class="fz" data-clipboard-target="#copy">复制编号</span>
          <span>订单编号</span>
        </div>
        <div class="total-right" id="copy">{{ details.code }}</div>
      </div>

      <div class="total-block" v-if="details.createTime">
        <div class="total-left">
          <span></span>
          <span>创建时间</span>
        </div>
        <div class="total-right">{{ details.createTime }}</div>
      </div>

      <div class="total-block" v-if="details.payTime">
        <div class="total-left">
          <span></span>
          <span>下单时间</span>
        </div>
        <div class="total-right">{{ details.payTime }}</div>
      </div>

      <div class="total-block" v-if="details.deliverTime">
        <div class="total-left">
          <span></span>
          <span>发货时间</span>
        </div>
        <div class="total-right">{{ details.deliverTime }}</div>
      </div>

      <div class="total-block" v-if="details.endTime">
        <div class="total-left">
          <span></span>
          <span>完成时间</span>
        </div>
        <div class="total-right">{{ details.endTime }}</div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="foot-order-btn-block">
      <!-- //-1：已取消，0：未支付，1：已支付待发货，2：已发货 -->
      <!-- <div class="btn" v-if="{{isType == 0  }}">取消订单</div> -->
      <!-- <div class="btn btns" v-if="{{isType == 0}}">立即支付</div> -->

      <div class="btn btnf" v-if="isType == 1 && time == 0" @click="remind">
        提醒发货
      </div>
      <div class="btn btnf op" v-if="isType == 1 && time > 0">{{ time }}</div>
      <div class="btn" v-if="isType == 2" @click="makePhoneCall">联系我们</div>

      <!-- <div class="btn btnf" v-if="isType == 2" @click="goExpress">查看物流</div> -->
      <!-- <div class="btn" v-if="isType == 4 || isType == 5">删除订单</div> -->
      <!-- <div class="btn" v-if="isType == 5" @click="goExpress">查看物流</div> -->
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import navbar from "@/components/navbar/navbar.vue";
export default {
  name: "OrderDetails",
  components: { navbar },
  props: {},
  data() {
    return {
      id: this.$route.query.id,
      isType: '',
      time: 0,
      currentTime: 20,

      details: {
        // id: "18675816471826432",
        // goodsAmount: 32, //货物金额
        // totalAmount: 32, //总金额
        // payAmount: 0, //支付金额
        // state: 2, //状态
        // code: "gfdgfdb",
        // channel: "WxApplet", //渠道编号
        // channelName: null, //渠道名
        // contactMobile: "18839135695", //联系电话
        // contactName: "???", //联系人
        // createTime: "2020-11-30 04:51:01", //创建时间
        // deliverTime: "2020-12-02 08:33:46", //发货时间
        // payTime: "2020-11-30 04:51:01", //支付时间
        // endTime: null, //完成时间
        // expressCompany: "shanghai", //快递公司
        // expressNumber: "??23", //快递单号
        // memberRemark: "测试订单-1-2", //会员备注
        // payAccount: "Test01033", //支付账号，卡号
        // payMethod: "兑换卡支付", //支付方式

        // products: [
        //   {
        //     //产品
        //     freeAmount: 0, //优惠金额
        //     payAmount: 0, //支付金额
        //     productId: "12045", //产品Id
        //     productImage:
        //       "http://qiniu.zdyxjx.com/product/upload_pic_1602311727337", //产品图片
        //     productName: "有机紫菜罐装", //产品名称
        //     quantity: 1, //产品数量
        //     salePrice: 32, //销售价格
        //     sku: "默认", //sku
        //     skuId: "2387", //SKU id
        //     supplierName: "", //供应商名称
        //   },
        // ],
      },
    };
  },
  watch: {},
  created() { },
  mounted() {
    this.getDetails() //获取订单详情
    this.fz();
    this.copy();
  },
  methods: {
    getDetails(e) {
      let _this = this;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$get("/order/api/Order/MyOrder/" + this.id, {}).then(
        (res) => {
          // console.log(res);
          if (res.data.code == 200) {
            // console.log(res.data);

            this.isType = res.data.data.state;
            this.details = res.data.data;
            this.$toast.clear() //关闭弹窗
          } else {
            this.$toast.fail(res.data.message);
          }

        }
      );
    },
    // 复制快递单号
    copy() {
      let ClipboardJSObj = new ClipboardJS('.copy') //className中有copyEle的元素
      //定义复制成功回调
      ClipboardJSObj.on('success', function (e) {
        alert('复制成功')
        e.clearSelection();
      });
      //定义复制失败回调
      ClipboardJSObj.on('error', function (e) {
        // alert('复制失败')
      });
    },
    // 复制订单号
    fz() {
      let ClipboardJSObj = new ClipboardJS('.fz') //className中有copyEle的元素
      //定义复制成功回调
      ClipboardJSObj.on('success', function (e) {
        alert('复制成功')
        e.clearSelection();
      });
      //定义复制失败回调
      ClipboardJSObj.on('error', function (e) {
        // alert('复制失败')
      });
    },
    //, 提醒发货
    remind() {
      var that = this;
      var currentTime = that.currentTime;
      this.$toast({
        message: "已提醒商家~",
      });
      that.time = currentTime;

      let interval = setInterval(function () {
        that.time = currentTime - 1;
        currentTime--;
        if (currentTime <= 0) {
          clearInterval(interval);
          that.time = 0;
          that.currentTime = 20;
        }
      }, 1000);
    },
    // 拨打客服电话
    makePhoneCall() {
      this.MakeCall() //拨打电话
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 0 0 50px;
  box-sizing: border-box;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  /* 顶部状态 */
  .header-block {
    text-align: left;
    height: 133px;
    width: 100%;
    background-image: url("https://qiniu.zdyxjx.com/minizdyxorder-top-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    .header-tips {
      position: absolute;
      bottom: 0;
      right: 0;
      height: 75px;
      width: 100%;
      background-image: url("https://qiniu.zdyxjx.com/minizdyxdui.png");
      background-repeat: no-repeat;
      background-size: 130px 130px;
      background-position: right -55px;
    }

    .header-tips-title {
      padding-left: 27px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 41px;
      color: #ffffff;
    }

    .header-tips-desc {
      padding-left: 27px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
    }
  }

  /* 物流信息 /收货地址 */
  .mation-block {
    text-align: left;
    height: 90px;
    background-color: #fff;
    margin: 15px 10px;
    padding: 0 10px;
    box-shadow: 0px 1.5px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .line {
      width: 1px;
      height: 48px;
      background-color: #cccccc;
    }

    .express-l {
      padding-top: 20px;
      width: 10px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 12px;
      color: #78849e;
      background-image: url("https://qiniu.zdyxjx.com/minizdyxexpress_icon.png");
      background-repeat: no-repeat;
      background-size: 10px 10px;
      background-position: 0 6px;
    }

    .address-l {
      padding-top: 20px;
      width: 10px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 12px;
      color: #78849e;
      background-image: url("https://qiniu.zdyxjx.com/minizdyxaddress_icon.png");
      background-repeat: no-repeat;
      background-size: 10px 10px;
      background-position: 0 6px;
    }

    .mation-info {
      /* background-color: paleturquoise; */
      width: 300px;
    }

    .mation-name {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .mation-name {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .mation-time {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #666666;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .mation-address {
      width: 100%;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }
  }
}
/* 物流信息 */
.delivery-block {
  display: flex;
  justify-content: space-around;
  align-items: center;
  // height: 90px;
  margin: 0 10px;
  padding: 5px 10px;
  border-top: 1px dashed #eeeeee;

  .delivery-line {
    width: 1px;
    height: 48px;
    background-color: #cccccc;
  }

  .delivery-express-l {
    padding-top: 20px;
    width: 10px;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 12px;
    color: #78849e;
    background-image: url("https://qiniu.zdyxjx.com/minizdyxexpress_icon.png");
    background-repeat: no-repeat;
    background-size: 10px 10px;
    background-position: 0 6px;
  }

  .delivery-info {
    /* background-color: paleturquoise; */
    width: 280px;
  }

  .delivery-name {
    width: 100%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }

  .delivery-time {
    width: 100%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }
}
// cell
.btb {
  // border-bottom: 1px solid #eeeeee;
  border-bottom: 1px dashed #eeeeee;
}
.cell-block {
  padding: 5px 10px;
  margin: 0 10px;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  .cell-tips {
    width: 40%;
    text-align: right;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #454f63;
  }
}
.total-block {
  padding: 5px 10px;
  margin: 0 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .total-left {
    width: 40%;
    text-align: right;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #454f63;
  }

  .total-right {
    width: 45%;
    text-align: right;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #78849e;
  }

  .total-tips {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 17px;
    color: #999999;
    margin-right: 10px;
  }

  .total-price {
    width: 30%;
    text-align: right;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 30px;
    color: #e95970;
  }
}

/* 订单详情 */
.order-detail {
  margin: 10px;
  padding: 10px 0;
  box-shadow: 0px 1.5px 4.5px rgba(69, 79, 99, 0.06);
  border-radius: 5px;
  background-color: #fff;
  text-align: left;

  .order-detail-tips {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    padding-left: 10px;
    border-left: 2.5px solid #00a8c0;
  }
}
/*商品详情*/
.goods-block {
  margin: 0 10px;
  background-color: #fff;
  box-shadow: 0px 2px 4.5px rgba(69, 79, 99, 0.06);
  border-radius: 5px;
  text-align: left;

  .order-info-block {
    padding: 10px 0;
    margin: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background-color: papayawhip;
  }

  .img {
    width: 145px;
    height: 145px;
  }

  .info-block {
    width: 200px;
  }

  .name {
    width: 100%;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #454f63;
    display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
    -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
    overflow: hidden; /*超出的文本隐藏*/
    text-overflow: ellipsis; /* 溢出用省略号*/
    -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
  }

  .desc {
    width: 100%;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #78849e;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }

  .udc {
    display: inline-block;
    background: #f9f9f9;
    padding: 2px 5px;

    border-radius: 5px;

    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #bbbbbb;
  }

  .price-block {
    margin-top: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30pxpx;
    color: #78849e;
  }

  .price-tips {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #cccccc;
  }

  .price {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #78849e;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .num {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #cccccc;
  }
}

/* 底部按钮 */
.foot-order-btn-block {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eee;

  box-shadow: 0px 2px 4.5px rgba(69, 79, 99, 0.06);
  /* background-color: paleturquoise; */
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    width: 90px;
    height: 25px;
    border: 1px solid #78849e;
    opacity: 1;
    border-radius: 14px;
    margin-right: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;

    color: #78849e;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btns {
    border: 1px solid #03a8c0;
    color: #03a8c0;
  }

  .btnf {
    border: 1px solid #03a8c0;
    background-color: #03a8c0;
    color: #fff;
  }

  .op {
    opacity: 0.5 !important;
  }
}

// 复制
.copy {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 17px;
  color: #00a8c0;
  margin-right: 10px;
}
.fz {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 17px;
  color: #e95970;
  margin-right: 10px;
}
</style>
